import moment from 'moment'
import NewsItem, { NewsItemAttrs } from '@/models/NewsItem'

type Attrs = {
  transactId: string
  items: NewsItemAttrs[]
}

export default class News {
  public transactId: string
  public items: NewsItem[]

  constructor({ transactId, items }: Attrs) {
    this.transactId = transactId
    this.items = items.map(item => new NewsItem(item))
  }

  findById(id: number) {
    return this.items.find(item => item.id === id)
  }

  indexOf(id: number) {
    return this.items.map(item => item.id).indexOf(id)
  }

  prev(id: number) {
    const currentIndex = this.indexOf(id)

    if (currentIndex <= 0) {
      return this.findById(id)
    }

    return this.items[currentIndex - 1]
  }

  next(id: number) {
    const currentIndex = this.indexOf(id)

    if (currentIndex >= this.items.length - 1) {
      return this.findById(id)
    }

    return this.items[currentIndex + 1]
  }

  delete(id: number) {
    const index = this.indexOf(id)

    if (index === -1) {
      return
    }

    this.items.splice(index, 1)

    return this
  }

  add(item: NewsItem) {
    if (item.id === undefined) {
      return
    }

    const current = this.findById(item.id)

    if (current) {
      const index = this.indexOf(item.id)
      this.items[index] = item
      return
    } else {
      this.items.push(item)
    }
  }

  has10DaysNews() {
    const diffs = this.items.map(n => Math.abs(moment(n.time).diff(moment(), 'hours')))
    const minDiff = Math.min(...diffs)

    return minDiff < 240
  }
}
